import type { ShortcutType } from "@/generated/models";
import { queryOptions } from "@tanstack/vue-query";
import { getRecents } from "ls/api/cloud/fs";

export const queries = {
  recents: (type?: ShortcutType) =>
    queryOptions({
      queryKey: ["recents", type] as const,
      queryFn: ({ signal }) => getRecents({ type }, { signal }),
    }),
};
